import { createStyleSheet } from 'Components/foundation/stylesheets';

const styles = createStyleSheet({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    alignItems: 'center',
    paddingTop: '40px',
    gap: '40px',
  },
  promptContainer: {
    display: 'flex',
    height: 'auto',
    width: '800px',
    boxShadow: '0px 16px 34px 0px #676C8308',
  },
});

export default styles;
